import styled from 'styled-components/macro'

export const Container = styled.section `
    display: flex;
    flex-direction: column;
    align-items: center;
    border-style: inset;
    margin: 0 auto;
    @media (min-width: 768px){
    }
`
